export default __webpack_public_path__ + "static/UChicago-logo-white-91fc6c258291b5990a5d1a01ec8f158d.svg";